module.exports = __webpack_public_path__ + "media/images/expand-close-icons-21cba2dfd1ded83dc7332a10e9fc6215.png";